
export const fetchStates = async (token, baseURL) => {
    const res = await fetch(`${baseURL}location/all-states`, {
    headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch states");
    return await res.json();
};
  
export const fetchBondDetails = async (bondId, token, baseURL) => {
    const res = await fetch(`${baseURL}largebond/${bondId}/details`, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch bond details");
    return await res.json();
};

export const addPowerToLargeBond = async ({ largeBondId, powerNumber, executionAmount, offense }) => {
    const token = localStorage.getItem("jwtToken");
    const baseURL = process.env.REACT_APP_BASE_URL;
  
    const res = await fetch(`${baseURL}largebond/${largeBondId}/power`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ powerNumber, executionAmount, offense }),
    });
  
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Failed to save power info: ${errorText}`);
    }
  
    return res;
};


  